import React, { useEffect } from 'react';

import './input-text.scss';

export interface InputTextProps {
	placeholder?: string;
	value: string;
	onChange?: (value: string) => void;
	readOnly?: boolean;
	error?: string | null;
	autoFocus?: boolean;
	className?: string;
}

export const InputText: React.FC<InputTextProps> = ({
	className,
	placeholder,
	value,
	onChange,
	readOnly,
	error,
	autoFocus,
}) => {
	const [focused, setFocused] = React.useState<boolean>(false);
	const [withValue, setWithValue] = React.useState<boolean>(false);

	useEffect(() => {
		if (value && value.length > 0) {
			setWithValue(true);
		} else {
			setWithValue(false);
		}
	}, [value]);

	const handleFocus = () => {
		setFocused(true);
	};

	const handleRemoveFocus = () => {
		setFocused(false);
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (onChange) {
			onChange(event.target.value);
		}
	};

	return (
		<div className={`input-text inputcomponent ${className ?? ''}`} title={placeholder}>
			<label
				className={` label ${focused && !readOnly ? 'focused' : ''} ${withValue ? 'value' : ''} ${error ? 'error' : ''}`}
			>
				<span className="label-title">{placeholder ?? 'Значение'}</span>
				<input
					type="text"
					value={value}
					className="input"
					autoFocus={autoFocus}
					onFocus={handleFocus}
					onBlur={handleRemoveFocus}
					onChange={handleChange}
					readOnly={readOnly}
				/>
			</label>
			{error && <div className="error">{error}</div>}
		</div>
	);
};
